import script from "./ContractHireAgreement.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContractHireAgreement.vue?vue&type=script&setup=true&lang=ts"

import "./ContractHireAgreement.vue?vue&type=style&index=0&id=7c0be6cb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c0be6cb"]])

export default __exports__